/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OutputGeoJsonGeometry } from './OutputGeoJsonGeometry';
import {
    OutputGeoJsonGeometryFromJSON,
    OutputGeoJsonGeometryFromJSONTyped,
    OutputGeoJsonGeometryToJSON,
} from './OutputGeoJsonGeometry';

/**
 * 
 * @export
 * @interface OutputGeoJsonFeature
 */
export interface OutputGeoJsonFeature {
    /**
     * 
     * @type {OutputGeoJsonGeometry}
     * @memberof OutputGeoJsonFeature
     */
    geometry: OutputGeoJsonGeometry;
    /**
     * 
     * @type {number}
     * @memberof OutputGeoJsonFeature
     */
    id?: number;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof OutputGeoJsonFeature
     */
    properties: { [key: string]: any; };
    /**
     * 
     * @type {string}
     * @memberof OutputGeoJsonFeature
     */
    type: string;
}

/**
 * Check if a given object implements the OutputGeoJsonFeature interface.
 */
export function instanceOfOutputGeoJsonFeature(value: object): boolean {
    if (!('geometry' in value)) return false;
    if (!('properties' in value)) return false;
    if (!('type' in value)) return false;
    return true;
}

export function OutputGeoJsonFeatureFromJSON(json: any): OutputGeoJsonFeature {
    return OutputGeoJsonFeatureFromJSONTyped(json, false);
}

export function OutputGeoJsonFeatureFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputGeoJsonFeature {
    if (json == null) {
        return json;
    }
    return {
        
        'geometry': OutputGeoJsonGeometryFromJSON(json['geometry']),
        'id': json['id'] == null ? undefined : json['id'],
        'properties': json['properties'],
        'type': json['type'],
    };
}

export function OutputGeoJsonFeatureToJSON(value?: OutputGeoJsonFeature | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'geometry': OutputGeoJsonGeometryToJSON(value['geometry']),
        'id': value['id'],
        'properties': value['properties'],
        'type': value['type'],
    };
}

